<template>
  <div>
    <b-row>
      <b-col 
        v-for="(gebrek,index) in onderdeel.gebreken" 
        :key="index" 
        lg="12" 
        xl="6"
      >
        <component 
          :is="gebrek.type ? gebrek.type : 'conditie'" 
          :gebrek="gebrek"
        >
          <b-btn
            variant="danger btn-sm pull-right"
            @click="onderdeel.gebreken.splice(index,1);"
          >
            <i class="fa fa-trash" />
          </b-btn>
        </component>
      </b-col>
      <b-col>
        <b-button-group>
          <b-button 
            variant="primary" 
            @click="addGebrek()"
          >
            <i class="fa fa-plus" /> Toevoegen
          </b-button>
          <b-button 
            variant="info" 
            @click="addNEN2767Gebrek()"
          >
            <i class="fa fa-book" /> NEN2767
          </b-button>
          <b-button 
            variant="warning" 
            @click="addOpmerking()"
          >
            <i class="fa fa-pencil" /> Opmerking
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-modal
      v-model="showNEN2767boek"
      title="NEN2767"
      size="lg"
      @ok="showNEN2767boek = false"
    >
      <b-tabs>
        <b-tab 
          v-for="tab in gebrekenboek" 
          :key="tab.label" 
          :title="tab.label"
        >
          <b-table
            :items="tab.children"
            :fields="['omschrijving','belang','intensiteit','omvang','code','conditie']"
            selectable
            select-mode="single"
            @row-selected="onRowSelected"
          >
            <template 
              slot="conditie" 
              scope="row"
            >
              <b-badge
                :class="getConditieClass(getConditieScore(row.item.belang,row.item.intensiteit,row.item.omvang))"
                pill
              >
                {{ getConditieScore(row.item.belang,row.item.intensiteit,row.item.omvang) }}
              </b-badge>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>
<script>
import Conditie from "../ConditieInvoer";
import Opmerking from "../OpmerkingInvoer";
import { conditieMixin } from "@/mixins/conditieMixin";
import { NEN2767Mixin } from "@/mixins/nen2767Mixin";

export default {
  name: "Gebreken",
  components: {
    Conditie,
    Opmerking,
  },
  mixins: [conditieMixin, NEN2767Mixin],
  props: {
    onderdeel: { type: Object,default: null },
    jaar: { type: Number, default: new Date().getFullYear() },
    presets: { type: Array, default: null },
    fotos: { type: Array, default: null }
  },
  data: function() {
    return {
      showNEN2767boek: false,
    }
  },
  methods: {
    addGebrek() {
      this.onderdeel.gebreken.push(this.nieuwGebrek("Nieuw gebrek",null,null,null));
    },
    addOpmerking() {
      this.onderdeel.gebreken.push({
        omschrijving: "Nieuwe opmerking",
        thumbs: [],
        type: 'opmerking'
      });
    },
    onRowSelected(row) {
      var g = row[0];
      this.onderdeel.gebreken.push( this.nieuwGebrek(g.omschrijving,g.belang,g.intensiteit,g.omvang));
      this.showNEN2767boek = false;
    },
    nieuwGebrek(omschrijving, belang, intensiteit, omvang) {
      return {
        NENomschrijving: '',
        omschrijving: omschrijving,
        thumbs: [],
        stuck: true,
        werkzaamheden: '',
        intensiteit: intensiteit,
        ap: {
          aspect:1,
          prioriteit:1
        },
        type:'conditie',
        conditieNa: 2,
        belang: belang,
        bedrag: 999,
        jaar: 2021,
        omvang: omvang
      }
    },

    addNEN2767Gebrek() {
      this.showNEN2767boek = true;
    }
  }
};
</script>